import { createFileRoute } from "@tanstack/react-router";

import UserProfilePage from "@/components/User/UserProfilePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

export const Route = createFileRoute("/_auth/account/profile")({
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {
          label: i18n.t("navigation.workspace"),
          icon: <Icon.WORKSPACE />,
          path: "/",
        },
        {
          label: i18n.t("navigation.account-settings"),
          icon: <Icon.USER_SETTINGS />,
          path: "/account/profile",
        },
      ],
    };
  },
  component: UserProfilePage,
});
